import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// Define the props interface with optional email
interface EmailVerificationProps {
  email?: string; // Make email optional by adding the ? mark
}

const EmailVerification: React.FC<EmailVerificationProps> = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [verifying, setVerifying] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        if (!token) {
          throw new Error('Verification token is missing');
        }
        
        console.log("Attempting to verify token:", token);
        
        const response = await fetch(`https://loaddrive-api.up.railway.app/api/auth/verify-email-token`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ token })
        });
        
        console.log("Response status:", response.status);
        
        if (response.ok) {
          navigate('/login', { 
            state: { message: 'Email verified successfully! You can now log in.' }
          });
        } else {
          setError('Verification failed. Please try again.');
          setVerifying(false);
        }
      } catch (error) {
        console.error('Verification error:', error);
        setError('Could not connect to verification service. Please try again.');
        setVerifying(false);
      }
    };
    
    verifyEmail();
  }, [token, navigate]);

  return (
    <div className="max-w-md mx-auto my-10 p-6 bg-white rounded-lg shadow-md">
      {verifying ? (
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-4">Verifying Your Email</h2>
          <p className="text-gray-600">Please wait while we verify your email address...</p>
          <div className="mt-4 flex justify-center">
            <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-blue-600"></div>
          </div>
        </div>
      ) : (
        <div className="text-center">
          <h2 className="text-2xl font-bold mb-4 text-red-600">Verification Failed</h2>
          <p className="text-gray-600">{error}</p>
          <button 
            className="mt-6 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
            onClick={() => navigate('/login')}
          >
            Return to Login
          </button>
        </div>
      )}
    </div>
  );
};

export default EmailVerification;
